import { twMerge } from "@/utils/twMerge";

export function UnreadCountBadge({ count, label }: { count: number; label: string }) {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      aria-label={label}
      className={twMerge(
        "absolute -right-1.5 -top-0.5 min-w-[17px] h-[17px] px-1 rounded-full",
        "bg-rose-500 text-white font-mono text-[14px] leading-5 tracking-tight",
        "flex items-center justify-center",
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
